<!--
 * @Author: zhouyan
 * @Date: 2025-06-03 11:42:09
 * @LastEditors: zhouyan
 * @LastEditTime: 2025-06-17 10:02:03
 * @Description: 
 * 
 * Copyright (c) 2025 by 重庆大学电子音像出版社有限公司, All Rights Reserved. 
-->
<script setup>
// App.vue 作为根组件，提供路由视图和全局消息提示
import Message from './components/Message.vue'
</script>

<template>
    
  
    <router-view v-slot="{ Component }">
            <component :is="Component" />
    </router-view>
    <Message />
   
</template>

<style>
/* 全局过渡动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* 重置一些基础样式 */
body {
    margin: 0;
    padding: 0;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #fff;
    color: #333;
}

#app {
    width: 100%;
    min-height: 100vh;
}
</style>